import React from 'react'
import * as yup from 'yup';
import TextField from '../../Reusable/Form/TextInput';
import Button from '../../Reusable/Button';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';

let extraMileOrderValidationForm = yup.object().shape({
  charge: yup.string().required("Extra Charge is required"),
  note: yup.string().required("Note is required")
});
const ExtraMile = (props:any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError
  } = useForm<any>({
    resolver: yupResolver(extraMileOrderValidationForm),
    defaultValues: async () => {
      return {
        charge: 0,
      }
    }
  })
  return (
    <div className='flex flex-col justify-between min-h-full'>
      <TextField
        label={"Charge"}
        register={register("charge")}
        errors={errors?.charge}
      />
      <TextField
        label={"Remarks"}
        register={register("note")}
        errors={errors?.note}
      />
      <div className="w-[100px] mr-4 absolute bottom-4 right-2">
        <Button
          label={"Submit"}
          onClick={handleSubmit((data: any) =>
            props?.handleActionMenu(data, "Extra Mile Charge", setError)
          )}
        />
      </div>
    </div>
  )
}

export default ExtraMile
